module.exports = __webpack_public_path__ + "src/img/upward.4c3b552f.svg";